import React from 'react';
import Admin from '../components/Admin';

export default Admin.compileFromLibrary([
  'GroupResource',
  {
    title: 'Library',
    archiveTitle: 'Library',
    archiveLabel: 'Library',
    icon: 'picture',
    archiveConfig: {
      icon: 'picture',
    },
    path: '/library',
    redirect: [['redirect.unauthorized']],
    archiveComponent: 'PageArchiveGrid',
    singleConfig: {
      hidden: true,
      alias: '/library',
    },
    filters: [
      ['FilterRegexSearch', {
        id: 'search',
        col: 24,
        paths: ['tags'],
        caseInsensitive: true,
        section: 'top',
      }],
      ['FilterPagination', {
        id: 'pagination',
        section: 'bottom',
      }],
    ],
    gridItemLink: '/library/:_id',
    renderGridItemContent: item => (
      <div className="tags">
        {
          item.tags.map((tag, i) => (
            // eslint-disable-next-line react/no-array-index-key
            <div key={`${tag}${i}`} className="tag">
              {tag}
            </div>
          ))
        }
      </div>
    ),
    fields: [
      ['FieldSelect', {
        name: 'tags',
        mode: 'tags',
        rules: [['validation.isRequired']],
      }],
      ['FieldUploadRefs', {
        name: 'file',
        label: 'Image',
        rules: [['validation.isRequired']],
        accept: 'image/*',
      }],
    ],
  },
]).pages;
